/*
 * Use enum, which is compiled into an object at runtime, so we can iterate
 * over its keys.
 */
export enum EFlags {
  aiGroupBuilder = 'aiGroupBuilder',
  bypassMX = 'bypassMX',
  consentBannerEnabled = 'consentBannerEnabled',
  creditCardConvenienceFeeAccepted = 'creditCardConvenienceFeeAccepted',
  csmManager = 'csmManager',
  enforceOnboarding = 'enforceOnboarding',
  entriDomainAuth = 'entriDomainAuth',
  hasBlackbaudRaisersEdge = 'hasBlackbaudRaisersEdge',
  hasGoogleAds = 'hasGoogleAds',
  hasImis = 'hasImis',
  hasMultiConversions = 'hasMultiConversions',
  importOrchestrator = 'importOrchestrator',
  locales = 'locales',
  metaIntegrationOutage = 'metaIntegrationOutage',
  minBudget = 'minBudget',
  monetization = 'monetization',
  noMaxBudget = 'noMaxBudget',
  noMinAudience = 'noMinAudience',
  overridePackageImplementationsAccess = 'overridePackageImplementationsAccess',
  pinpoint = 'pinpoint',
  pinpointSendAllEmails = 'pinpointSendAllEmails',
  publishDomainEvents = 'publishDomainEvents',
  raisersEdgeOnMagpie = 'raisersEdgeOnMagpie',
  showAccountReports = 'showAccountReports',
  showAPIKeysV2 = 'showAPIKeysV2',
  showAllAffinityAudiences = 'showAllAffinityAudiences',
  showCampaignRecommendations = 'showCampaignRecommendations',
  showConversionsSettingsV2 = 'showConversionsSettingsV2',
  showDripBulkEnroll = 'showDripBulkEnroll',
  showDripCampaigns = 'showDripCampaigns',
  showCommandPalette = 'showCommandPalette',
  showEmailABTesting = 'showEmailABTesting',
  showForms = 'showForms',
  showFundraise = 'showFundraise',
  showFundraiseCRM = 'showFundraiseCRM',
  showGrowthCredits = 'showGrowthCredits',
  showImportRunDetails = 'showImportRunDetails',
  showNewPrimaryNav = 'showNewPrimaryNav',
  showOnboarding = 'showOnboarding',
  showProResources = 'showProResources',
  showUsageMetrics = 'showUsageMetrics',
  showUsersAndRolesV2 = 'showUsersAndRolesV2',
  useContactLimits = 'useContactLimits',
  useEmailLimits = 'useEmailLimits',
  virtuous = 'virtuous',
  zapier = 'zapier',
  showGoalsV2 = 'showGoalsV2',
}

export type TFlags = keyof typeof EFlags;

export type TFlagsRecord = Partial<Record<TFlags, boolean>>;
